// extracted by mini-css-extract-plugin
export var messageSideLeft = "_n8-1";
export var stateContainer = "_n8-0";